<template>
    <div class="bg-blue-600 flex rounded w-full my-2">
      <rectangle v-if='holder' :bounds='bounds' :parent-container='holderContainer' :render-tools='renderTools' />
      <transform-ghost v-if='holder'
                       :transform='clonedTransform'
                       :parent-transform='parentTransform'
                       :parent-container='holderContainer'
                       :render-tools='renderTools'
                       :partutil='partutil'
                       :key='transform.id' />
        <!--
        <grid class="m-auto mx-4 text-blue-900" />
      <div class="my-auto">
        <span class="pr-3 text-white" >Grid</span>
        <span class="pr-3" >X</span>
        <span class="bg-blue-700 text-black">{{component.gridx}}</span>
        <span class="pl-3 pr-3" >Y</span>
        <span class="bg-blue-700 text-black">{{component.gridy}}</span>
      </div>
        -->

    </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import Grid from '@icons/Grid.vue';
import Rectangle from '@edit/atoms/Rectangle.vue';
import TransformGhost from '@edit/atoms/TransformGhost.vue';
function round(p, n) {
  return (p % n < n / 2 ? p - (p % n) : p + n - (p % n));
  return p - 1;
  p *= 1000;
  n *= 1000;
  //const rest = p - Math.floor(p);
  //if (p > 
  return (p % n < n / 2 ? p - (p % n) : p + n - (p % n)) / 1000;
}

export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    parentTransform:{
      type:Object,
      required:true
    },
    moveable: {
      type:Object,
      default() {
        return undefined;
      }
    },
    renderTools: {
      type:Object,
      default() {
        return undefined;
      }
    },
    holder: {
      type:Object,
      required:true,
      default() {
        return undefined;
      }
    },
    updateContainerBounds: {
      type:Function,
      default() {
        return () => { }
      },
    },
    partutil: {
      type:Object,
      required:true
    }
  },
  data() {
    const clonedTransform = cloneDeep(this.transform);
    clonedTransform.id = clonedTransform.id + '-snapped';
    //const component = this.partutil.findComponentForTransform(this.parentTransform);
    const component = {
      gridx:1,
      gridy:1
    }

    const inSnapX = parseFloat(component.gridx);
    const inSnapY = parseFloat(component.gridy);
    return {
      clonedTransform,
      component,
      inSnapX,
      inSnapY,
      snappedPos:{
        x:this.transform.transform.pos.x,
        y:this.transform.transform.pos.y
      }
    }
  },
  mounted() {
    this.dragKey = this.parentTransform.id + '-' + this.transform.id;
    if (this.moveable) {
      this.moveable.$on('onDragStart', this.onDragStart);
      this.moveable.$on('onDrag', this.onDrag);
      this.moveable.$on('onDragEnd', this.onDragEnd);
    }
  },
  beforeDestroy() {
    if (this.moveable) {
      this.moveable.$off('onDragStart', this.onDragStart);
      this.moveable.$off('onDrag', this.onDrag);
      this.moveable.$off('onDragEnd', this.onDragEnd);
    }
  },
  components:{
    Rectangle,
    TransformGhost,
    //Grid
  },
  methods:{
    onDragStart({id}) {
      if (id !== this.dragKey) {
        return;
      }
      this.startAlpha = this.transform.transform.alpha;
      this.transform.transform.alpha = 0;
    },
    onDragEnd({id}) {
      if (id !== this.dragKey) {
        return;
      }
      this.renderTools.addToRunBatch( () => {
        this.snapToGrid(this.inSnapX, this.inSnapY);
        this.transform.transform.pos.x = this.snappedPos.x;
        this.transform.transform.pos.y = this.snappedPos.y;
        this.transform.transform.alpha = this.startAlpha;

        this.renderTools.addToUpdateBatch(this.holder);
        this.renderTools.addToRunBatch( () => {
          this.updateContainerBounds(true);
        });
      });
    },
    onDrag({id}) {
      if (id !== this.dragKey) {
        return;
      }
      const {scale} = this.transform.transform;
      if (false && (Math.abs(scale.x - this.component.gridx) > 0.01 
          || Math.abs(scale.y - this.component.gridy) > 0.01)) {
        console.log('set scale', this.component.gridx, this.component.gridy);
        scale.x = this.component.gridx;
        scale.y = this.component.gridy;
      }
      this.snapToGrid(this.inSnapX, this.inSnapY);
      this.renderTools.addToUpdateBatch(this.holder);
    },
    onChange(in_nv, in_ov) {
      const type = 'vars';
      const nv = {
        delay: in_nv
      }
      const ov = {
        delay: in_ov
      }
      this.$emit("change", {
          nv,
          ov,
          type
      });
    },
    snapToGrid(gridx, gridy) {
      const snapped = this.renderTools.snapToGrid({
        position:{
          x:this.transform.transform.pos.x,
          y:this.transform.transform.pos.y
        },
        grid:{
          x:gridx,
          y:gridy
        }
      });


      this.snappedPos.x = snapped.x;
      this.snappedPos.y = snapped.y;

      this.$set(this.clonedTransform.transform.pos, 'x', this.snappedPos.x);
      this.$set(this.clonedTransform.transform.pos, 'y', this.snappedPos.y);
    }
  },
  computed:{
    bounds() {
      const pos = this.snappedPos;
      const width = this.inSnapX;
      const height = this.inSnapY;
      return {
        x1:pos.x - width/2,
        y1:pos.y - height/2,
        x2:pos.x + width/2,
        y2:pos.y + height/2
      };
    },
    holderContainer() {
      return this.holder.getContainer().parent;
    },
    targetContainer() {
      return this.holder.getContainer();
    }
  },
  watch:{
    transform() {
      this.dragKey = this.parentTransform.id + '-' + this.transform.id;
    },
    parentTransform() {
      this.dragKey = this.parentTransform.id + '-' + this.transform.id;
    }
  }
}
</script>
